<template>
    <div class="glyph-block-char-container">
      <p class="glyph-block-title">{{ title }}</p>
      <div class="glyph-block-char-grid">
        <div v-for="(char, index) in characters" :key="index" @click="$emit('char-selected', char); handleClick($event);" class='glyph-character'>
          {{ char }}
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  
  defineProps({
    title: String,
    characters: Array
  });

function handleClick(e) {
  const clickedGlyph = e.currentTarget;
  const glyphCharacters = document.querySelectorAll('.glyph-character'); 
  if (glyphCharacters.length == 0) return;
  
  glyphCharacters.forEach(character => {
    character.classList.remove('active');
  });

  clickedGlyph.classList.add('active');
}
  </script>